import { createApi } from "@reduxjs/toolkit/query/react";
import { axiosBaseQuery } from "../libs/core/axios-base-query";


export const appApi = createApi({
  reducerPath: "appApi",
  baseQuery: axiosBaseQuery({ baseUrl: "https://api.admasyouth.org/api" }),
  tagTypes: [
    "User",
    "Project",
    "UnitTypes",
    "Blogs",
    "Teams",
    "Units",
    "Subscribers",
    "ScheduledVisit",
    "Testimonials",
    "Partners",
    "BankAccounts",
    "dashboardSummary",
    "Messages",
    "Newsletter",
    "ProjectDetail",
    "Galleries",
    "Categories",
    "Programs",
    "Impacts",
    "Vacancies",
    "Volunteers"
  ],
  endpoints: () => ({}),
});
